import { render } from "./InterestSettings.vue?vue&type=template&id=e954046e&scoped=true"
import script from "./InterestSettings.vue?vue&type=script&lang=js"
export * from "./InterestSettings.vue?vue&type=script&lang=js"

import "./InterestSettings.vue?vue&type=style&index=0&id=e954046e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e954046e"]])

export default __exports__